var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-md-editor',{attrs:{"left-toolbar":"undo redo link bold  italic","right-toolbar":"preview","mode":"edit"},model:{value:(_vm.cValue),callback:function ($$v) {_vm.cValue=$$v},expression:"cValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }